import React from 'react';
import Icon from '.';

const CheckboxIndeterminateIcon = props => (
	<Icon {...props} viewBox="0 0  24 24">
		<g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
			<path
				d="M5,4 L19,4 C19.5522847,4 20,4.44771525 20,5 L20,19 C20,19.5522847 19.5522847,20 19,20 L5,20 C4.44771525,20 4,19.5522847 4,19 L4,5 C4,4.44771525 4.44771525,4 5,4 Z M8,11 L8,13 L16,13 L16,11 L8,11 Z"
				fill="#5CB247"
			/>
		</g>
	</Icon>
);

export default CheckboxIndeterminateIcon;
